// extracted by mini-css-extract-plugin
export var callCard = "_ok-0";
export var callMessageButton = "_ok-1";
export var helpIcon = "_ok-3";
export var helpIconContainer = "_ok-4";
export var verticalDivider = "_ok-2";